import React from 'react';

export default function JobFilterFieldSkeleton({ label, color }) {
	return (
		<div className="group">
			{label && (
				<div className="block text-sm font-semibold text-gray-700 mb-2" style={{ color }}>
					{label}
				</div>
			)}
			<div className="mt-2">
				<div className="relative">
					<input
						disabled
						   className="group-hover:shadow-xl group-hover:shadow-gray-200/60 w-full min-w-lg cursor-pointer rounded-xl border-0 bg-white/95 backdrop-blur-sm py-2 pr-12 text-gray-900 font-medium shadow-lg shadow-gray-200/50 ring-1 ring-gray-200"
					/>
				</div>
			</div>
		</div>
	);
}
